<template>
  <v-list-item title="Version" @click="openVersion" />
  <v-dialog v-model="open" max-width="420px">
    <v-card>
      <v-card-title>Version</v-card-title>
      <v-card-text>
        <div class="mb-2">mose-web</div>
        <div class="version-details">
          <div>Commit: {{ version.shortCommit }}</div>
          <div>Commit date (UTC): {{ version.dateLabel }}</div>
        </div>
        <p v-if="copyMessage" class="mt-3" role="status">{{ copyMessage }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="copyVersion">Copy version</v-btn>
        <v-spacer />
        <v-btn @click="open = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { formatWebVersion } from '../utils/webVersion.mjs'

const version = formatWebVersion(
  process.env.VUE_APP_WEB_COMMIT,
  process.env.VUE_APP_WEB_COMMITTED_AT,
)
const open = ref(false)
const copyMessage = ref('')

function openVersion() {
  copyMessage.value = ''
  open.value = true
}

async function copyVersion() {
  try {
    await navigator.clipboard.writeText(version.copyText)
    copyMessage.value = 'Version copied.'
  } catch {
    copyMessage.value = 'Unable to copy. Select the version details above to copy manually.'
  }
}
</script>

<style scoped>
.version-details {
  user-select: text;
}
</style>
